import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import ChatSandbox from './components/ChatSandbox'; // Keep purely for route safety if needed
import ChatterDashboard from './pages/ChatterDashboard';

// Helper for Protected Routes
const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Admin Route */}
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/chatter" 
            element={
              <PrivateRoute>
                <ChatterDashboard />
              </PrivateRoute>
            } 
          />

          {/* Redirect Root to Admin (or Login) */}
          <Route path="/" element={<Navigate to="/admin" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;